import { RequestService, type RequestOptions } from '../request-service';
import { ManagedApps } from './managed-apps';
import type {
  ManagedAppsRequest,
  ManagedAppsResponse,
} from '@wix/ambassador-devcenter-managedapps-v1-managed-app/types';
import type RpcModule from '@wix/ambassador-devcenter-managedapps-v1-managed-app/rpc';
import type HttpModule from '@wix/ambassador-devcenter-managedapps-v1-managed-app/http';

type RpcModuleType = typeof RpcModule;
type HttpModuleType = typeof HttpModule;

export class ManagedAppsService extends RequestService<
  RpcModuleType,
  HttpModuleType
> {
  protected async rpcModule(): Promise<RpcModuleType> {
    return import('@wix/ambassador-devcenter-managedapps-v1-managed-app/rpc');
  }

  protected async httpModule(): Promise<HttpModuleType> {
    return import('@wix/ambassador-devcenter-managedapps-v1-managed-app/http');
  }

  public async get(payload: ManagedAppsRequest, options?: RequestOptions) {
    const response = await this.request<
      ManagedAppsRequest,
      ManagedAppsResponse
    >({
      methodName: 'managedApps',
      payload,
      options,
    });
    return new ManagedApps(response.managedApps || []);
  }
}
